import React, { useState } from "react";
import AddNewVendor from "./AddVendor";
import AddExistingVendor from "./AddExistingVendor";
import { Row, Form } from "react-bootstrap";
import "./AddVendor.css";

const AddVendorContainer = () => {
  const [selectedChkBoxId, setSelectedChkBoxId] = useState("newVendor");

  const onFormChange = (e) => {
    setSelectedChkBoxId(e.target.name);
  };
  return (
    <div className="addVendor_container">
      <Row className="addVendor_container_title">
        <Form onChange={onFormChange}>
          <Form.Check
            inline
            type="checkbox"
            label="Add New Vendor"
            name="newVendor"
            data-testid="addVendor_addNew"
            checked={selectedChkBoxId === "newVendor"}
          />
          <Form.Check
            inline
            type="checkbox"
            label="Add Existing Vendor"
            name="existingVendor"
            data-testid="addVendor_addExisting"
            checked={selectedChkBoxId === "existingVendor"}
          />
        </Form>
      </Row>
      <Row style={{ marginBottom: 40 }}>
        {selectedChkBoxId === "newVendor" ? (
          <AddNewVendor />
        ) : (
          <AddExistingVendor />
        )}
      </Row>
    </div>
  );
};

export default AddVendorContainer;
